import { ErrorBoundary } from 'react-error-boundary';
import { useSelector, useDispatch } from 'react-redux';

import { Drawer, DrawerContent } from '@frontend/components';

import { FullSizeErrorFallback } from 'modules/common/modals/nestModuleModal/errorBoundary';

import { LinearNestingDefaultsForm, SheetNestingDefaultsForm } from '.';
import { drawer } from './data/actions';
import { isOpen, isLinearNest } from './data/reducer';

export const NestingDefaultsDrawer = () => {
  const dispatch = useDispatch();
  const isDrawerOpen = useSelector(isOpen);
  const isLinear = useSelector(isLinearNest);
  const handleClose = () => {
    dispatch(drawer.close());
  };
  return (
    <Drawer size={'lg'} isOpen={isDrawerOpen} onClose={handleClose}>
      <DrawerContent display={'flex'} flexDir={'column'} maxWidth={'32.5rem'}>
        <ErrorBoundary
          FallbackComponent={FullSizeErrorFallback}
          onError={(error) =>
            console.error('Error occurred in NestingDefaultsForm', error)
          }
        >
          {isLinear ? (
            <LinearNestingDefaultsForm />
          ) : (
            <SheetNestingDefaultsForm />
          )}
        </ErrorBoundary>
      </DrawerContent>
    </Drawer>
  );
};
